// extracted by mini-css-extract-plugin
module.exports = {"main":"Error_main__KJO6_","content":"Error_content___bpFk","illustration":"Error_illustration__AMate"};